export default function FacebookIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g opacity="0.4">
        <path
          d="M7.7875 12.925H9.0625C9.175 12.925 9.2875 13.0375 9.2875 13.15V21.175C9.2875 21.5875 9.625 21.925 10.0375 21.925H12.9625C13.375 21.925 13.7125 21.5875 13.7125 21.175V13.15C13.7125 13.0375 13.825 12.925 13.9375 12.925H16.0375C16.4125 12.925 16.75 12.6625 16.7875 12.2875L17.275 9.3625C17.35 8.9125 16.975 8.4625 16.525 8.4625H14.05C13.8625 8.4625 13.7125 8.3125 13.7125 8.125V6.25C13.7125 5.7625 13.975 5.5 14.4625 5.5H16.675C17.0875 5.5 17.425 5.1625 17.425 4.75V1.75C17.425 1.3375 17.0875 1 16.675 1H14.0125C9.1375 1 9.25 4.9375 9.25 5.5V8.2375C9.25 8.35 9.1375 8.4625 9.025 8.4625H7.75C7.3375 8.4625 7 8.8 7 9.2125V12.1375C7.0375 12.5875 7.375 12.925 7.7875 12.925Z"
          fill="#F2F4F6"
        />
      </g>
    </svg>
  )
}
